"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Vector = /** @class */ (function () {
    function Vector(input, length) {
        if (Array.isArray(input)) {
            this.array = input.map(function (item) { return parseInt(item, 10); });
            return;
        }
        if (!length) {
            this.array = [];
            return;
        }
        var arr = Array.from(input.replace(/\D+/g, "")).map(function (item) {
            return parseInt(item);
        });
        var missing = length - arr.length;
        if (missing > 0) {
            for (var index = 0; index < missing; index++) {
                arr.unshift(0);
            }
        }
        else {
            for (var index = 0; index < Math.abs(missing); index++) {
                arr.shift();
            }
        }
        this.array = arr;
    }
    Vector.prototype.mult = function (other) {
        var res = 0;
        var length = Math.min(this.array.length, other.array.length);
        for (var index = 0; index < length; index++) {
            res = res + this.array[index] * other.array[index];
        }
        return res;
    };
    Vector.prototype.get = function (index) {
        return this.array[index];
    };
    return Vector;
}());
exports.default = Vector;
